import React from 'react'
import {createPortal} from 'react-dom'
import Button from './Button'

interface NoAuditModalProps {
  isOpen: boolean
  onClose: () => void
  onLogout: () => void
  users: any[]
}

const NoAuditModal: React.FC<NoAuditModalProps> = ({ isOpen, onClose, onLogout, users }) => {
  if (!isOpen) return null

  const modalContent = (
    <div
      className='modal fade show d-block'
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.5)' }}
      tabIndex={-1}
    >
      <div className='modal-dialog modal-dialog-centered'>
        <div className='modal-content'>
          <div className='modal-body text-center px-6 pb-6'>
            <div className='mb-8 mt-4'>
              <img src='/media/logos/Audits-icon.svg' alt='no audit' />
            </div>
            <h3 className='fw-bold mb-4'>No Audits Assigned</h3>
            <p className='text-gray-800 fs-7 mb-2'>
              There are currently no audits assigned to your account. Once your organization
              assigns an audit, it will appear here for your review.
            </p>
            <p className='text-gray-800 fs-7 mb-8'>
              <strong>Note:</strong> When you are assigned an audit, you will receive an email<br /> notification.
            </p>
            <div className='d-flex justify-content-center gap-3 mb-2'>
              {/* <Button
                btnType='primary'
                onClick={() => {
                  window.location.href = `mailto:${users[0].email}`
                }}
              >
                Contact Organization
              </Button> */}
              <Button
                btnType='default'
                onClick={onLogout}
              >
                Logout
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )

  return createPortal(modalContent, document.body)
}

export default NoAuditModal 